import styles from "./DigitalServices.module.css";
import { useLanguage } from "../../LanguageContext";
import { useAppConfig } from "../../hooks/useAppConfig";
import DigitalServiceCard from "./DigitalServiceCard";
import web1 from "../../assets/web1s.mp4";
import web2 from "../../assets/web2s.mp4";

function DigitalServices() {
    const { language, specializedText, servicesText } = useLanguage();

    const dynamicStyles = {
        fontFamily: language === "ARM" && "Mardoto",
        fontWeight: language === "ARM" && 500,
    };

    const config = useAppConfig();

    const isArmenian = language === "ARM";

    const serviceCards = servicesText ? [
        {
            id: 1,
            title: servicesText[language]?.digitalCard1Title || "",
            description: servicesText[language]?.digitalCard1Description || "",
            url: servicesText[language]?.digitalCard1Url || "",
            video: web1,
        },
        {
            id: 2,
            title: servicesText[language]?.digitalCard2Title || "",
            description: servicesText[language]?.digitalCard2Description || "",
            url: servicesText[language]?.digitalCard2Url || "",
            video: web2,
        },
    ] : [];

    return (
        <div className={`${styles.serviceCardsContainer} ${isArmenian ? styles.armLanguage : ""}`}>
            <div className={styles.serviceCards}>
                <div className={styles.serviceCardsHeader}>
                    <span style={dynamicStyles}>{servicesText?.[language]?.digitalServicesHeader || "Arca's services"}</span>
                    <div className={styles.serviceCardsHeaderIcons}>
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M0.0164407 3.82196L0 12L3.99046 12L3.99046 3.99715C4.00629 3.99715 4.9794 4.00325 4.9794 4.0002L12 4.0002L12 -5.24537e-07L3.83761 -1.67747e-07C1.73064 -7.56487e-08 0.0219223 1.70984 0.0176598 3.82196"
                                fill="#243BE2"
                            />
                        </svg>
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M8.17804 11.9836L0 12L0 8.00954L8.00285 8.00954C8.00285 7.99371 7.99675 7.0206 7.9998 7.0206L7.9998 0H12L12 8.16239C12 10.2694 10.2902 11.9781 8.17804 11.9823"
                                fill="#ADF233"
                            />
                        </svg>
                    </div>
                </div>
                <div className={styles.serviceCardsTitle}>
                    <h1 style={dynamicStyles}>{servicesText?.[language]?.digitalServicesTitle || "Full range of Arca digital services"}</h1>
                    <p style={dynamicStyles}>{servicesText?.[language]?.digitalServicesDescription || "These banks are live on ArcaPay, delivering secure, real-time interbank payments."}</p>
                </div>
            </div>

            <div className={styles.serviceCardsWrapper}>
                {serviceCards.map((card) => (
                    <DigitalServiceCard key={card.id} title={card.title} description={card.description} url={card.url} video={card.video} />
                ))}
            </div>
        </div>
    );
}

export default DigitalServices;
